import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const CloseButtonComponent = ({ handleClick }: $TSMigrationFixMe) => {
  return (
    <div className='d-flex justify-content-end w-100'>
      <FontAwesomeIcon
        // @ts-expect-error TS(2820): Type '"fa-circle-xmark"' is not assignable to type...
        icon={["fal", "fa-circle-xmark"]}
        size='2x'
        onClick={handleClick}
        className='direct-access-close my-4 mx-4'
      />
    </div>
  )
}

export default CloseButtonComponent
